<div class="sky-card">
  <div class="sky-card-header">
    <h1 class="h2 mb-0">Items</h1>
  </div>
  <div class="sky-card-body">
    <div class="grid grid-2">
      <a class="container" [routerLink]="'/item/field-guide'">
        <mat-icon class="menu-icon">photo_library</mat-icon>
        <span class="menu-label">
          Field guide
        </span>
      </a>
      <a class="container" [routerLink]="'/item/unlock'">
        <mat-icon class="menu-icon">lock_open</mat-icon>
        <span class="menu-label">
          Quick unlock
        </span>
      </a>
    </div>
  </div>
</div>

<!-- Categories -->
<div class="sky-card mt">
  <div class="sky-card-header">
    <h2 class="h3 mb-0">Type</h2>
  </div>
  <div class="sky-card-body">
    <app-item-type-selector [type]="type" (typeChanged)="onTypeChanged($event)"></app-item-type-selector>
  </div>
</div>

<!-- Items -->
<div class="sky-card mt" *ngIf="shownItems?.length">
  <div class="sky-card-header">
    <div class="unlock-bar">
      You have unlocked
      <b [class.completed]="shownUnlocked == shownItems.length">{{ shownUnlocked }}</b>
      out of
      <b [class.completed]="shownUnlocked == shownItems.length">{{ shownItems.length }}</b>
      items.
      <div class="none-toggle" [style.opacity]="(shouldShowNone ? 1 : 0.5)" (click)="toggleNone()">
        <mat-icon svgIcon="none" [ngbTooltip]="'Toggle unequip icon'" container="body" placement="left"></mat-icon>
      </div>
      <div class="column-toggle">
        <mat-icon (click)="setColumns()" [ngbTooltip]="'Toggle column size'" container="body" placement="left">apps</mat-icon>
      </div>
    </div>
  </div>

  <div class="sky-card-body">
    <div class="flex item-grid" [class.gap-half-y]="columns">
      <div class="item-icon" *ngIf="showNone">
        <div class="item-none">
          <mat-icon class="" svgIcon="none"></mat-icon>
        </div>
        <mat-icon class="unlock-check self unlocked">done</mat-icon>
      </div>
      <ng-container *ngFor="let item of shownItems; let i = index">
        <div class="item-col-hr" [style.display]="!columns || !i || ((i+offsetNone) % (columns)) ? undefined : 'block'"></div>
        <a class="item-icon" [routerLink]="['/item', item.guid]">
          <app-item-icon [item]="item" [showSubIcons]="true"
            [class.highlight]="item && item === selectedItem"
            [class.item-unlocked]="item.unlocked && (item.type !== typeEmote || item.level! >= emoteLevels[item.name])"
            [ngbTooltip]="item.name" container="body" placement="auto" >
          </app-item-icon>
          <mat-icon class="unlock-check" [class.self]="item.type !== typeEmote || item.level! >= emoteLevels[item.name]" [class.unlocked]="item.unlocked">done</mat-icon>
          <!-- Favourite (bottom left) -->
          <mat-icon *ngIf="item.favourited" class="img-bl">star</mat-icon>
        </a>
      </ng-container>
    </div>
  </div>
</div>
